/* eslint-disable require-unicode-regexp  */

export var getConfluencePageAri = function getConfluencePageAri(pageId, cloudId) {
  var pageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'page';
  return "ari:cloud:confluence:".concat(cloudId, ":").concat(pageType, "/").concat(pageId);
};
export var getPageIdAndTypeFromAri = function getPageIdAndTypeFromAri(ari) {
  var match = ari.match(/ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/);
  if (match !== null && match !== void 0 && match[2]) {
    return {
      type: match[1],
      id: match[2]
    };
  }
  throw new Error("Invalid page ARI: ".concat(ari));
};
export var getLocalIdFromAri = function getLocalIdFromAri(ari) {
  var match = ari.match(/ari:cloud:confluence:[^:]+:(page|blogpost)\/\d+\/([a-zA-Z0-9-]+)/);
  if (match !== null && match !== void 0 && match[2]) {
    return match[2];
  }
  throw new Error("Invalid page ARI: ".concat(ari));
};
export var getPageARIFromResourceId = function getPageARIFromResourceId(resourceId) {
  var match = resourceId.match(/(ari:cloud:confluence:[^:]+:(page|blogpost)\/\d+)\/([a-zA-Z0-9-]+)$/);
  if (match !== null && match !== void 0 && match[1]) {
    return match[1];
  }
  throw new Error("Invalid resourceId: ".concat(resourceId));
};
export var getContentPropertyAri = function getContentPropertyAri(contentPropertyId, cloudId) {
  return "ari:cloud:confluence:".concat(cloudId, ":content/").concat(contentPropertyId);
};
export var resourceIdFromSourceAndLocalId = function resourceIdFromSourceAndLocalId(sourceId, localId) {
  return sourceId + '/' + localId;
};